import styled from "styled-components/macro";

export const LiItem = styled.span`
  font-size: 18px;
  color: ${(props) => props.theme.colors.text};
  margin: 0;
  &:before {
    content: "\\2022";
    color: ${(props) => props.theme.colors.primary};
    width: 1em;
    margin: 0 14px;
  }
`;
